import React from 'react';
import classnames from 'classnames';

const Tooltip = ({ children, content: Content }) => {
	// Wrap class name
	const wrap = classnames(
		'relative group w-fit'
	);

	// Tooltip class name
	const tooltip = classnames(
		'absolute py-1 px-2 rounded-lg shadow-md hidden group-hover:block',
		'-translate-y-full -translate-x-1/2 -top-1 left-1/2'
	);

	return (
		<div className={wrap}>
			<div className={tooltip}>
				<Content />
			</div>
			
			{children}
		</div>
	);
};

export default Tooltip;